// removed by extract-text-webpack-plugin
module.exports = {"indent":"_1Z2jY1-Pmc4Km-7lsJ1qe2","reminders":"_13SK_dan9IsaSzgtaBGAxI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectStatisticsOverall/ProjectStatisticsOverall.scss
// module id = 1382
// module chunks = 1